import {
	format,
	addDays,
	startOfDay,
	endOfDay,
	startOfTomorrow,
	endOfTomorrow,
	startOfWeek,
	endOfWeek,
	startOfMonth,
	endOfMonth
} from 'date-fns';

import { gte, lte } from 'lodash-es';

const dateFormat = 'MM-dd-yyyy';
export const getCurrentDate = () => {
	const today = new Date();
	return format(endOfDay(today), dateFormat);
};

export const addDaysToCurrentDate = (days = 30) => format(addDays(new Date(), days), dateFormat);

export const lastOneMonthList = (list, dateProp) => {
	var today = new Date();
	var last30DaysBackDate = today.setDate(today.getDate() - 30);
	var date30DaysBack = new Date(last30DaysBackDate);

	return list.filter(item => item[dateProp] >= date30DaysBack);
};

export const tomorrow = () => {
	const today = new Date();
	const nextDay = new Date(today);
	nextDay.setDate(nextDay.getDate() + 1);

	return nextDay;
};

export const timeFromNow = time => {
	let unixTime = new Date(time).getTime();
	if (!unixTime) return;
	let now = new Date().getTime();

	// Calculate difference
	let difference = unixTime / 1000 - now / 1000;
	return Math.floor((-1 * difference) / (60 * 60 * 24));
};

export const isPast = sessionDateTime => timeFromNow(sessionDateTime) >= 0;

export const yesterday = () => {
	const today = new Date();
	const previousDay = new Date(today);
	previousDay.setDate(previousDay.getDate() - 1);

	return previousDay;
};

export const getPreviousWeek = () => {
	const today = new Date();
	const weekBack = new Date(today);
	weekBack.setDate(weekBack.getDate() - 7);

	return weekBack;
};

export const getNextWeek = () => {
	const today = new Date();
	const nextWeek = new Date(today);
	nextWeek.setDate(nextWeek.getDate() + 7);

	return nextWeek;
};

export const getPreviousMonth = () => {
	const today = new Date();
	const previousMonth = new Date(today);
	previousMonth.setMonth(previousMonth.getMonth() - 1);

	return previousMonth;
};

export const getNextMonth = () => {
	const today = new Date();
	const nextMonth = new Date(today);
	nextMonth.setMonth(nextMonth.setMonth() + 1);

	return nextMonth;
};

export const isDateWithinRange = (actualDate, range) => {
	return gte(actualDate, range.startDate) && lte(actualDate, range.endDate);
};

export const getCustomDateRange = (dateToRange, rangeType = 'month') => {
	let startDate;
	let endDate;
	switch (rangeType) {
		case 'day':
			startDate = startOfDay(dateToRange);
			endDate = endOfDay(dateToRange);
			break;
		case 'month':
			startDate = startOfMonth(dateToRange);
			endDate = endOfMonth(dateToRange);
			break;
		case 'week':
		default:
			startDate = startOfWeek(dateToRange);
			endDate = endOfWeek(dateToRange);
			break;
	}

	return { startDate, endDate };
};

export const DATE_FILTER_TYPE = {
	TODAY: 'TODAY',
	TOMORROW: 'TOMORROW',
	LAST_WEEK: 'LAST_WEEK',
	THIS_WEEK: 'THIS_WEEK',
	NEXT_WEEK: 'NEXT_WEEK',
	LAST_MONTH: 'LAST_MONTH',
	THIS_MONTH: 'THIS_MONTH',
	NEXT_MONTH: 'NEXT_MONTH'
};

export const SESSION_FILTERS = [
	{
		title: 'Last Month',
		key: DATE_FILTER_TYPE.LAST_MONTH
	},
	{
		title: 'Last Week',
		key: DATE_FILTER_TYPE.LAST_WEEK
	},
	{
		title: 'Today',
		key: DATE_FILTER_TYPE.TODAY
	},
	{
		title: 'Tomorrow',
		key: DATE_FILTER_TYPE.TOMORROW
	},
	{
		title: 'This Week',
		key: DATE_FILTER_TYPE.THIS_WEEK
	},
	{
		title: 'Next Week',
		key: DATE_FILTER_TYPE.NEXT_WEEK
	},
	{
		title: 'This Month',
		key: DATE_FILTER_TYPE.THIS_MONTH
	},
	{
		title: 'Next Month',
		key: DATE_FILTER_TYPE.NEXT_MONTH
	}
];

export const getDateRange = filterType => {
	let range = getCustomDateRange(new Date(), 'week');
	switch (filterType) {
		case DATE_FILTER_TYPE.TODAY:
			range = getCustomDateRange(new Date(), 'day');
			break;
		case DATE_FILTER_TYPE.TOMORROW:
			range = { startDate: startOfTomorrow(), endDate: endOfTomorrow() };
			break;
		case DATE_FILTER_TYPE.LAST_WEEK:
			range = getCustomDateRange(getPreviousWeek(), 'week');
			break;
		case DATE_FILTER_TYPE.THIS_WEEK: // Default
			range = getCustomDateRange(new Date(), 'week');
			break;
		case DATE_FILTER_TYPE.NEXT_WEEK:
			range = getCustomDateRange(getNextWeek(), 'week');
			break;
		case DATE_FILTER_TYPE.LAST_MONTH:
			range = getCustomDateRange(getPreviousMonth(), 'month');
			break;
		case DATE_FILTER_TYPE.THIS_MONTH:
			range = getCustomDateRange(new Date(), 'month');
			break;
		case DATE_FILTER_TYPE.NEXT_MONTH:
			range = getCustomDateRange(getNextMonth(), 'month');
			break;
		default:
			break;
	}

	return range;
};
